"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.hero.title': 'Account Activation',
    'activate.hero.description': 'Welcome to IntHub! We\'re activating your account to get you started.',
    'activate.hero.login_link_text': 'Already have an active account?',
    'activate.hero.login_link': 'Sign in here',
};
